import {
  Http,
  Storage,
  TokenManager
} from "vuezx"

const state = {
  roles: []
}

const mutations = {
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // 登录
  login({
    commit
  }, config) {
    // 清空token
    TokenManager.clear()
    let url = "/account/login"
    Http.get({
      baseURL: global.API_BASE_PATH,url: global.setUrl(url, config.params, true),
      success: (response) => {
        if (response.message == "success") {
          // 设置token
          TokenManager.set(response.data.token)
          config.success(response);
        } else {
          config.error(response);
        }
      }
    })
  },
  // 获取用户信息
  getInfo({
    commit
  }, config) {
    let url = "/account/getUser"
    Http.get({
      url: url,
      success: (response) => {
        if (response.message == "success") {
          if(response.data){
            // 存储用户信息
            commit('SET_ROLES', response.data)
            config.success(response.data);
          }
        } else {
          config.error();
        }
      }
    })
  },
  // 获取机构信息
  getOrgListByAppId({
    commit
  }, config) {
    let url = "/org/getOrgListByAppId"
    Http.get({
      url: url,
      success: (response) => {
        if (response.message == "success") {
          config.success(response.data);
        }
      }
    })
  },
  // 设置orgCode(机构code)
  orgCodeInit(commit, orgCode) {
    // 存储机构orgCode
    Storage.set('orgCode', orgCode);
    global.orgCode = orgCode
  },
  // 退出登录
  logout({
    commit,
    state
  }) {
    TokenManager.clear()
    // 清除机构orgCode
    Storage.remove('orgCode');
    global.orgCode = ''
    commit('SET_ROLES', [])
  },

  // 删除token
  resetToken({
    commit,
    state
  }) {
    TokenManager.clear()
    commit('SET_ROLES', [])
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
